import { Component, Inject, OnDestroy } from "@angular/core";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import { PersonDataService } from "../../../core/persons.dataservice";
import { ConfirmDialog } from "../../../shared/confirm-dialog.component";
import { AuthServerProvider } from "../../../shared/auth/auth.service";

import * as fileHelper from "../../../shared/file.helper";
import * as dataCore from "../../../core/datacore";

@Component({
    selector: "crew-person-edit-competence",
    template: require('./person.competence.edit.component.html'),
    styles: [require('../../../shared/label-button.css')]
})
export class PersonCompetenceEditComponent implements OnDestroy {

    private unsubribe: Function;

    public hasExistingFile: boolean;
    private newFile: File = null;
    private shouldRemoveExistingFile: boolean = false;

    public ValidFrom: Date;
    public ExpirationDate: Date;

    public get checkValidFrom(): boolean {
        return !this.ValidFrom;
    }

    public get checkExpiration(): boolean {
        return !this.ExpirationDate;
    }

    constructor(
        @Inject(PersonDataService.Id) private personDataService: PersonDataService,
        @Inject("person") person: Nema.Crew.Model.Person,
        @Inject("personCompetence") public personCompetence: Nema.Crew.Model.PersonCompetence,
        @Inject("competenceGroup") competenceGroup: Nema.Crew.Model.CompetenceGroup,
        @Inject("competenceTypes") public competenceTypes: Nema.Crew.Model.CompetenceType[],
        private stateService: StateService,
        transitionService: TransitionService,
        private dialog: MatDialog,
        @Inject('$log') private $log: ng.ILogService,
        @Inject("isNew") private isNew: boolean,
        private authServerProvider: AuthServerProvider) {

        this.ValidFrom = dataCore.addTimezoneOffset(this.personCompetence.ValidFrom);
        this.ExpirationDate = dataCore.addTimezoneOffset(this.personCompetence.Expiration);

        this.personName = person.Name;
        this.competenceGroupName = competenceGroup.Name;

        this.hasExistingFile = !!this.personCompetence.AttachmentFileContentId;

        this.cleanUpSubscription();

        this.unsubribe = transitionService.onBefore({}, transition => {

            var hasChanges = this.personDataService.hasChanges();
            if (hasChanges) {

                let dialogRef = this.dialog.open(ConfirmDialog);

                dialogRef.componentInstance.content = "There are unsaved changes, do you want to continue?";
                dialogRef
                    .afterClosed()
                    .subscribe(res => {
                        if (res) {
                            this.rejectChanges();
                            transition.run();
                        }
                    });

                return false;
            }

            return true;
        });
    }

    public personName: string;

    public competenceGroupName: string;

    public entityDisplayName = "Person Competence";

    public listStateName = "app.resources.persons.detail";

    private cleanUpSubscription() {
        if (this.unsubribe) {
            this.unsubribe();
            this.unsubribe = null;
        }
    }

    public ngOnDestroy() {
        this.cleanUpSubscription();
    }

    public save() {

        if (this.isNew) {
            let tmp = this.personCompetence;
            this.personCompetence = this.personDataService.newPersonCompetence(tmp.PersonId, tmp.CompetenceTypeId);
            this.personCompetence.Description = tmp.Description;
            this.personCompetence.DocumentRefNr = tmp.DocumentRefNr;
            this.personCompetence.HasAttachment = tmp.HasAttachment;
            this.personCompetence.IsValidated = tmp.IsValidated;
        }

        this.personCompetence.ValidFrom = dataCore.subtractTimezoneOffset(this.ValidFrom);
        this.personCompetence.Expiration = dataCore.subtractTimezoneOffset(this.ExpirationDate);
        

        var self = this;

        // Save the Person Competence
        this.personDataService
            .save(self.personCompetence.Person)
            .then(() => {
                if (this.newFile) {
                    return this.personDataService.saveFileContent(this.newFile, fileHelper.getPersonCompetenceFileDownloadUrl(this.personCompetence.Id));
                } else if (this.shouldRemoveExistingFile) {
                    return this.personDataService.deleteFileContent(fileHelper.getPersonCompetenceFileDownloadUrl(this.personCompetence.Id));
                }
            })
            .then(() => {
                this.$log.info("Successfully saved " + this.entityDisplayName);
                this.backToList();
            })
            .catch(err => this.$log.error("Could not save " + this.entityDisplayName + ", error occurred: " + err));
    }

    private rejectChanges() {
        this.personDataService.rejectChanges();
    }

    public cancel() {
        this.rejectChanges();
        this.backToList();
    }

    public backToList(): void {
        this.stateService.go(this.listStateName, { id: this.personCompetence.PersonId });
    }

    public setNewFile(file: File) {
        this.newFile = file;
    }

    public downloadFile() {
        window.open(fileHelper.getPersonCompetenceFileDownloadUrl(this.personCompetence.Id, this.authServerProvider.getToken()));
    }
    
    public setExistingFileShouldBeRemoved() {
        this.shouldRemoveExistingFile = true;
    }

    public getTodayOrNull(checked: boolean): Date {
        return dataCore.getTodayOrNull(checked);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/competences/person.competence.edit.component.ts